import { NSFunctions } from './utils/functions';
import QuestionIcon from 'bootstrap-icons/icons/question-lg.svg?raw';
import CameraIcon from 'bootstrap-icons/icons/camera-video.svg?raw';
import { NSPageLabels } from './page_labels';
import { xCore, xCoreHelper } from './core';

export let NSHelp = {}

NSHelp.init = function() {
    NSHelpPrivate.init();

    this.f_open = function () { return NSHelpPrivate.f_open.apply( NSHelpPrivate, arguments ); };
}

let NSHelpPrivate = 
{
    init: function() {
        const e_placelholder = document.createElement("div");
        const s_tooltip = NSPageLabels.f_get_label_text_by_internal_name('faq_button_tooltip');
        const s_tooltip_how_to_use = NSPageLabels.f_get_label_text_by_internal_name('help_how_to_use_button_tooltip');

        const button_faq_id = "button_faq";
        const button_how_to_use_id = "button_how_to_use_id";

        e_placelholder.innerHTML = `
            <div class="btn-group btn-group-sm" role="group">
                <button id="${button_faq_id}" type="button" class="btn btn-sm btn-outline-secondary" title="${s_tooltip}">
                    ${QuestionIcon}
                </button>
                <button id="${button_how_to_use_id}" type="button" class="btn btn-sm btn-outline-secondary" title="${s_tooltip_how_to_use}">
                    ${CameraIcon}
                </button>
            </div>
        `;
        
        const e_parent = document.querySelector("#header-actions-toolbar");
        const s_selector = '#header-main-buttons';

        this.element = NSFunctions.f_dom_elem_preappend_dom_childs_by_html(e_parent, e_placelholder, s_selector);

        //this.element.querySelector('button').onclick = () => { this.f_open(); };
        document.getElementById(button_faq_id).onclick = () => { this.f_open(); };
        document.getElementById(button_how_to_use_id).onclick = () => { this.f_open_help_how_to_use(); };
    },
    f_open: function() {
        window.open("./faqs_geocascais.pdf", '_blank');
    },
    f_open_help_how_to_use: function() {
        let s_help_how_to_use_url = xCore.application.endpoints.help_how_to_use_url;
        window.open(s_help_how_to_use_url, '_blank');
    }

    
    
}
	